import React from 'react';
import { ThemeProvider } from '@material-ui/core/styles';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import { CookiesProvider } from 'react-cookie';
import theme from './App.theme';
import routes from '../constants/routes';
import { SecuredRoute, NoMatch, Banner } from '../components/common';
import LocaleProvider from '../components/common/LocaleProvider/LocaleProvider';
import AlertProvider from '../components/common/AlertProvider/AlertProvider';
import HomePage from '../components/HomePage/HomePage';
import EnterCode from '../components/EnterCode/EnterCode';
import PreScreenInstructions from '../components/PreScreenInstructions/PreScreenInstructions';
import CreateUser from '../components/CreateUser/CreateUser';
import Questionnaire from '../components/Questionnaire/Questionnaire';
import ClearCache from '../components/ClearCache/ClearCache';
import SignOut from '../components/SignOut/SignOut';
import { Approved, LowRisk, HighRisk } from '../components/ResultPages';

export default () => (
  <ThemeProvider theme={theme}>
    <LocaleProvider>
      <AlertProvider>
        <CookiesProvider>
          <BrowserRouter >
            <Banner />
            <Switch>
              <Route exact path={routes.HOME_PAGE} component={HomePage} />
              <Route path={routes.ENTER_CODE} component={EnterCode} />
              <SecuredRoute
                path={routes.PRE_SCREEN_INSRUCTIONS}
                component={PreScreenInstructions}
              />
              <SecuredRoute
                path={routes.CREATE_ACCOUNT}
                component={CreateUser}
              />
              <SecuredRoute
                path={routes.QUESTIONAIRE}
                component={Questionnaire}
              />
              <Route path={routes.APPROVED} component={Approved} />
              <Route path={routes.LOW_RISK} component={LowRisk} />
              <Route path={routes.HIGH_RISK} component={HighRisk} />
              <Route path={routes.CLEAR_CACHE} component={ClearCache} />
              <SecuredRoute path={routes.SIGN_OUT} component={SignOut} />
              <Route component={NoMatch} />
            </Switch>
          </BrowserRouter>
        </CookiesProvider>
      </AlertProvider>
    </LocaleProvider>
  </ThemeProvider>
);
